export default __webpack_public_path__ + "static/media/camview-thumb.cd56f126.webp";